export class SapAgentCommand {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "kind",
            "baseName": "kind",
            "type": "SapAgentCommandKind",
            "format": ""
        },
        {
            "name": "operationId",
            "baseName": "operationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetVersion",
            "baseName": "targetVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "artifactUrl",
            "baseName": "artifactUrl",
            "type": "string",
            "format": "uri"
        },
        {
            "name": "artifactSha256",
            "baseName": "artifactSha256",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SapAgentCommand.attributeTypeMap;
    }
    constructor() {
    }
}
